export class RoleResponseModel {
    id: string;
    name: string;
    partnerId: string;
    rolePermissions: string[];
}
export class PermissionsResponseModel {
    permissions: string[];

}
export class PermissionGroupResponsemodel {
    categoryName: string;
    permissions = new Array<Permissions>();
}
export class Permissions {
    permission: string;
    name: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/role/RoleResponseModel.ts